module.exports = __webpack_public_path__ + "img/logo-fr.bd4e63b1.png";